const selectors = {
    featuredMenuItems: '.strawberry_featured_menu .item',
    productsItems: '.strawberry_products .item',
    images: '.product_image img'
};

class StrawberryMenu {
    constructor() {
        this.menuItems = document.querySelectorAll(selectors.featuredMenuItems);
        this.productItems = document.querySelectorAll(selectors.productsItems);
        this.images = document.querySelectorAll(selectors.images);
        this._setupEventListeners();
    }

    _setupEventListeners() {
        this.menuItems.forEach((item, index) => {
            item.addEventListener('click', () => this._handleMenuItemClick(index));
        });
    }

    _handleMenuItemClick(index) {
        this.menuItems.forEach(item => item.classList.remove('active'));
        this.menuItems[index].classList.add('active');
        this.productItems.forEach(item => item.style.display = 'none');
        this.productItems[index].style.display = 'flex';
    }
}

document.addEventListener('DOMContentLoaded', () => new StrawberryMenu());